<template>
  <div>
    <b-row>
      <b-col cols="12">
        <EddCounterVueContainer />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import { Helper } from "../../helpers";
import AppHeader from "../../components/header/header";
import EddCounterVueContainer from "../../containers/EddCounterVueContainer.vue";
// import { HTTP } from "../../utils/HTTP";
export default {
  name: "ClientProfileEdd",
  components: {
    AppHeader,
    EddCounterVueContainer
  },
  data() {
    return {};
  },

  computed: {},
  methods: {}
};
</script>

<style scoped>
</style>
